import mapboxgl from "mapbox-gl";
import {
    genericPointLayer,
    hoverablePointLayer,
    addLayersIfNotExist,
} from "../../map/layers/generics";

import { breaksSources } from "./sources";

export const breaksPositionLyr = genericPointLayer(
    "breaksPositionLyr",
    breaksSources.breaksSrc,
    6
);

export const breaksPositionHighlightLyr = hoverablePointLayer(
    "breaksPositionHighlightLyr",
    breaksSources.breaksSrc,
    10,
    "skyblue"
);

export const addAllLayersInOrder = (map: mapboxgl.Map): void => {
    addLayersIfNotExist(map, [breaksPositionHighlightLyr, breaksPositionLyr]);
};
